define(function () {
  var BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz'

  function int2char (n) {
    return BI_RM.charAt(n)
  }

  function BigInteger (a, b, c) {
    if (a != null) {
      if (typeof a === 'number') this.fromNumber(a, b, c)
      else if (b == null && typeof a !== 'string') this.fromString(a, 256)
      else this.fromString(a, b)
    }
  }

  /**
    *
    *  Secure Hash Algorithm (SHA256)
    *  http://www.webtoolkit.info/
    *
    *  Original code by Angel Marin, Paul Johnston.
    *
    **/

  function SHA256 (s) {
    var chrsz = 8
    var hexcase = 0

    function safe_add (x, y) {
      var lsw = (x & 0xFFFF) + (y & 0xFFFF)
      var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
      return (msw << 16) | (lsw & 0xFFFF)
    }

    function S (X, n) { return (X >>> n) | (X << (32 - n)) }
    function R (X, n) { return (X >>> n) }
    function Ch (x, y, z) { return ((x & y) ^ ((~x) & z)) }
    function Maj (x, y, z) { return ((x & y) ^ (x & z) ^ (y & z)) }
    function Sigma0256 (x) { return (S(x, 2) ^ S(x, 13) ^ S(x, 22)) }
    function Sigma1256 (x) { return (S(x, 6) ^ S(x, 11) ^ S(x, 25)) }
    function Gamma0256 (x) { return (S(x, 7) ^ S(x, 18) ^ R(x, 3)) }
    function Gamma1256 (x) { return (S(x, 17) ^ S(x, 19) ^ R(x, 10)) }

    function core_sha256 (m, l) {
      var K = new Array(0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0xFC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x6CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2)
      var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19)
      var W = new Array(64)
      var a, b, c, d, e, f, g, h, i, j
      var T1, T2

      m[l >> 5] |= 0x80 << (24 - l % 32)
      m[((l + 64 >> 9) << 4) + 15] = l

      for (var i = 0; i < m.length; i += 16) {
        a = HASH[0]
        b = HASH[1]
        c = HASH[2]
        d = HASH[3]
        e = HASH[4]
        f = HASH[5]
        g = HASH[6]
        h = HASH[7]

        for (var j = 0; j < 64; j++) {
          if (j < 16) W[j] = m[j + i]
          else W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16])

          T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j])
          T2 = safe_add(Sigma0256(a), Maj(a, b, c))

          h = g
          g = f
          f = e
          e = safe_add(d, T1)
          d = c
          c = b
          b = a
          a = safe_add(T1, T2)
        }

        HASH[0] = safe_add(a, HASH[0])
        HASH[1] = safe_add(b, HASH[1])
        HASH[2] = safe_add(c, HASH[2])
        HASH[3] = safe_add(d, HASH[3])
        HASH[4] = safe_add(e, HASH[4])
        HASH[5] = safe_add(f, HASH[5])
        HASH[6] = safe_add(g, HASH[6])
        HASH[7] = safe_add(h, HASH[7])
      }
      return HASH
    }

    function str2binb (str) {
      var bin = Array()
      var mask = (1 << chrsz) - 1
      for (var i = 0; i < str.length * chrsz; i += chrsz) {
        bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - i % 32)
      }
      return bin
    }

    function Utf8Encode (string) {
      string = string.replace(/\r\n/g, '\n')
      var utftext = ''

      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n)

        if (c < 128) {
          utftext += String.fromCharCode(c)
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192)
          utftext += String.fromCharCode((c & 63) | 128)
        } else {
          utftext += String.fromCharCode((c >> 12) | 224)
          utftext += String.fromCharCode(((c >> 6) & 63) | 128)
          utftext += String.fromCharCode((c & 63) | 128)
        }
      }

      return utftext
    }

    function binb2hex (binarray) {
      var hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef'
      var str = ''
      for (var i = 0; i < binarray.length * 4; i++) {
        str += hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8 + 4)) & 0xF) +
                hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8)) & 0xF)
      }
      return str
    }

    s = Utf8Encode(s)
    return binb2hex(core_sha256(str2binb(s), s.length * chrsz))
  }

  var sha256 = {}
  sha256.hex = function (s) {
    return SHA256(s)
  }

  /**
    *
    *  Secure Hash Algorithm (SHA1)
    *  http://www.webtoolkit.info/
    *
    **/

  function SHA1 (msg) {
    function rotate_left (n, s) {
      var t4 = (n << s) | (n >>> (32 - s))
      return t4
    };

    function lsb_hex (val) {
      var str = ''
      var i
      var vh
      var vl

      for (i = 0; i <= 6; i += 2) {
        vh = (val >>> (i * 4 + 4)) & 0x0f
        vl = (val >>> (i * 4)) & 0x0f
        str += vh.toString(16) + vl.toString(16)
      }
      return str
    };

    function cvt_hex (val) {
      var str = ''
      var i
      var v

      for (i = 7; i >= 0; i--) {
        v = (val >>> (i * 4)) & 0x0f
        str += v.toString(16)
      }
      return str
    };

    function Utf8Encode (string) {
      string = string.replace(/\r\n/g, '\n')
      var utftext = ''

      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n)

        if (c < 128) {
          utftext += String.fromCharCode(c)
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192)
          utftext += String.fromCharCode((c & 63) | 128)
        } else {
          utftext += String.fromCharCode((c >> 12) | 224)
          utftext += String.fromCharCode(((c >> 6) & 63) | 128)
          utftext += String.fromCharCode((c & 63) | 128)
        }
      }

      return utftext
    };

    var blockstart
    var i, j
    var W = new Array(80)
    var H0 = 0x67452301
    var H1 = 0xEFCDAB89
    var H2 = 0x98BADCFE
    var H3 = 0x10325476
    var H4 = 0xC3D2E1F0
    var A, B, C, D, E
    var temp

    msg = Utf8Encode(msg)

    var msg_len = msg.length

    var word_array = new Array()
    for (i = 0; i < msg_len - 3; i += 4) {
      j = msg.charCodeAt(i) << 24 | msg.charCodeAt(i + 1) << 16 |
            msg.charCodeAt(i + 2) << 8 | msg.charCodeAt(i + 3)
      word_array.push(j)
    }

    switch (msg_len % 4) {
      case 0:
        i = 0x080000000
        break
      case 1:
        i = msg.charCodeAt(msg_len - 1) << 24 | 0x0800000
        break

      case 2:
        i = msg.charCodeAt(msg_len - 2) << 24 | msg.charCodeAt(msg_len - 1) << 16 | 0x08000
        break

      case 3:
        i = msg.charCodeAt(msg_len - 3) << 24 | msg.charCodeAt(msg_len - 2) << 16 | msg.charCodeAt(msg_len - 1) << 8 | 0x80
        break
    }

    word_array.push(i)

    while ((word_array.length % 16) != 14) word_array.push(0)

    word_array.push(msg_len >>> 29)
    word_array.push((msg_len << 3) & 0x0ffffffff)

    for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
      for (i = 0; i < 16; i++) W[i] = word_array[blockstart + i]
      for (i = 16; i <= 79; i++) W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1)

      A = H0
      B = H1
      C = H2
      D = H3
      E = H4

      for (i = 0; i <= 19; i++) {
        temp = (rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5A827999) & 0x0ffffffff
        E = D
        D = C
        C = rotate_left(B, 30)
        B = A
        A = temp
      }

      for (i = 20; i <= 39; i++) {
        temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1) & 0x0ffffffff
        E = D
        D = C
        C = rotate_left(B, 30)
        B = A
        A = temp
      }

      for (i = 40; i <= 59; i++) {
        temp = (rotate_left(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8F1BBCDC) & 0x0ffffffff
        E = D
        D = C
        C = rotate_left(B, 30)
        B = A
        A = temp
      }

      for (i = 60; i <= 79; i++) {
        temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6) & 0x0ffffffff
        E = D
        D = C
        C = rotate_left(B, 30)
        B = A
        A = temp
      }

      H0 = (H0 + A) & 0x0ffffffff
      H1 = (H1 + B) & 0x0ffffffff
      H2 = (H2 + C) & 0x0ffffffff
      H3 = (H3 + D) & 0x0ffffffff
      H4 = (H4 + E) & 0x0ffffffff
    }

    var temp = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4)

    return temp.toLowerCase()
  }

  var sha1 = {}
  sha1.hex = function (s) {
    return SHA1(s)
  }

  // Copyright (c) 2005  Tom Wu
  // All Rights Reserved.
  // See "LICENSE" for details.
  // Basic JavaScript BN library - subset useful for RSA encryption.

  // Bits per digit
  var dbits

  // JavaScript engine analysis
  var canary = 0xdeadbeefcafe
  var j_lm = ((canary & 0xffffff) == 0xefcafe)

  // (public) Constructor

  function BigInteger (a, b, c) {
    if (a != null) {
      if (typeof a === 'number') this.fromNumber(a, b, c)
      else if (b == null && typeof a !== 'string') this.fromString(a, 256)
      else this.fromString(a, b)
    }
  }

  // return new, unset BigInteger

  function nbi () {
    return new BigInteger(null)
  }

  // am: Compute w_j += (x*this_i), propagate carries,
  // c is initial carry, returns final carry.
  // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
  // We need to select the fastest one that works in this environment.
  // am1: use a single mult and divide to get the high bits,
  // max digit bits should be 26 because
  // max internal value = 2*dvalue^2-2*dvalue (< 2^53)

  function am1 (i, x, w, j, c, n) {
    while (--n >= 0) {
      var v = x * this[i++] + w[j] + c
      c = Math.floor(v / 0x4000000)
      w[j++] = v & 0x3ffffff
    }
    return c
  }
  // am2 avoids a big mult-and-extract completely.
  // Max digit bits should be <= 30 because we do bitwise ops
  // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)

  function am2 (i, x, w, j, c, n) {
    var xl = x & 0x7fff,
      xh = x >> 15
    while (--n >= 0) {
      var l = this[i] & 0x7fff
      var h = this[i++] >> 15
      var m = xh * l + h * xl
      l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff)
      c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30)
      w[j++] = l & 0x3fffffff
    }
    return c
  }
  // Alternately, set max digit bits to 28 since some
  // browsers slow down when dealing with 32-bit numbers.

  function am3 (i, x, w, j, c, n) {
    var xl = x & 0x3fff,
      xh = x >> 14
    while (--n >= 0) {
      var l = this[i] & 0x3fff
      var h = this[i++] >> 14
      var m = xh * l + h * xl
      l = xl * l + ((m & 0x3fff) << 14) + w[j] + c
      c = (l >> 28) + (m >> 14) + xh * h
      w[j++] = l & 0xfffffff
    }
    return c
  }
  if (j_lm && (navigator.appName == 'Microsoft Internet Explorer')) {
    BigInteger.prototype.am = am2
    dbits = 30
  } else if (j_lm && (navigator.appName != 'Netscape')) {
    BigInteger.prototype.am = am1
    dbits = 26
  } else { // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3
    dbits = 28
  }

  BigInteger.prototype.DB = dbits
  BigInteger.prototype.DM = ((1 << dbits) - 1)
  BigInteger.prototype.DV = (1 << dbits)

  var BI_FP = 52
  BigInteger.prototype.FV = Math.pow(2, BI_FP)
  BigInteger.prototype.F1 = BI_FP - dbits
  BigInteger.prototype.F2 = 2 * dbits - BI_FP

  // Digit conversions
  var BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz'
  var BI_RC = new Array()
  var rr, vv
  rr = '0'.charCodeAt(0)
  for (vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv
  rr = 'a'.charCodeAt(0)
  for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv
  rr = 'A'.charCodeAt(0)
  for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv

  function int2char (n) {
    return BI_RM.charAt(n)
  }

  function intAt (s, i) {
    var c = BI_RC[s.charCodeAt(i)]
    return (c == null) ? -1 : c
  }

  // (protected) copy this to r

  function bnpCopyTo (r) {
    for (var i = this.t - 1; i >= 0; --i) r[i] = this[i]
    r.t = this.t
    r.s = this.s
  }

  // (protected) set from integer value x, -DV <= x < DV

  function bnpFromInt (x) {
    this.t = 1
    this.s = (x < 0) ? -1 : 0
    if (x > 0) this[0] = x
    else if (x < -1) this[0] = x + DV
    else this.t = 0
  }

  // return bigint initialized to value

  function nbv (i) {
    var r = nbi()
    r.fromInt(i)
    return r
  }

  // (protected) set from string and radix

  function bnpFromString (s, b) {
    var k
    if (b == 16) k = 4
    else if (b == 8) k = 3
    else if (b == 256) k = 8 // byte array
    else if (b == 2) k = 1
    else if (b == 32) k = 5
    else if (b == 4) k = 2
    else {
      this.fromRadix(s, b)
      return
    }
    this.t = 0
    this.s = 0
    var i = s.length,
      mi = false,
      sh = 0
    while (--i >= 0) {
      var x = (k == 8) ? s[i] & 0xff : intAt(s, i)
      if (x < 0) {
        if (s.charAt(i) == '-') mi = true
        continue
      }
      mi = false
      if (sh == 0) this[this.t++] = x
      else if (sh + k > this.DB) {
        this[this.t - 1] |= (x & ((1 << (this.DB - sh)) - 1)) << sh
        this[this.t++] = (x >> (this.DB - sh))
      } else this[this.t - 1] |= x << sh
      sh += k
      if (sh >= this.DB) sh -= this.DB
    }
    if (k == 8 && (s[0] & 0x80) != 0) {
      this.s = -1
      if (sh > 0) this[this.t - 1] |= ((1 << (this.DB - sh)) - 1) << sh
    }
    this.clamp()
    if (mi) BigInteger.ZERO.subTo(this, this)
  }

  // (protected) clamp off excess high words

  function bnpClamp () {
    var c = this.s & this.DM
    while (this.t > 0 && this[this.t - 1] == c)--this.t
  }

  // (public) return string representation in given radix

  function bnToString (b) {
    if (this.s < 0) return '-' + this.negate().toString(b)
    var k
    if (b == 16) k = 4
    else if (b == 8) k = 3
    else if (b == 2) k = 1
    else if (b == 32) k = 5
    else if (b == 64) k = 6
    else if (b == 4) k = 2
    else return this.toRadix(b)
    var km = (1 << k) - 1,
      d, m = false,
      r = '',
      i = this.t
    var p = this.DB - (i * this.DB) % k
    if (i-- > 0) {
      if (p < this.DB && (d = this[i] >> p) > 0) {
        m = true
        r = int2char(d)
      }
      while (i >= 0) {
        if (p < k) {
          d = (this[i] & ((1 << p) - 1)) << (k - p)
          d |= this[--i] >> (p += this.DB - k)
        } else {
          d = (this[i] >> (p -= k)) & km
          if (p <= 0) {
            p += this.DB
            --i
          }
        }
        if (d > 0) m = true
        if (m) r += int2char(d)
      }
    }
    return m ? r : '0'
  }

  // (public) -this

  function bnNegate () {
    var r = nbi()
    BigInteger.ZERO.subTo(this, r)
    return r
  }

  // (public) |this|

  function bnAbs () {
    return (this.s < 0) ? this.negate() : this
  }

  // (public) return + if this > a, - if this < a, 0 if equal

  function bnCompareTo (a) {
    var r = this.s - a.s
    if (r != 0) return r
    var i = this.t
    r = i - a.t
    if (r != 0) return r
    while (--i >= 0) if ((r = this[i] - a[i]) != 0) return r
    return 0
  }

  // returns bit length of the integer x

  function nbits (x) {
    var r = 1,
      t
    if ((t = x >>> 16) != 0) {
      x = t
      r += 16
    }
    if ((t = x >> 8) != 0) {
      x = t
      r += 8
    }
    if ((t = x >> 4) != 0) {
      x = t
      r += 4
    }
    if ((t = x >> 2) != 0) {
      x = t
      r += 2
    }
    if ((t = x >> 1) != 0) {
      x = t
      r += 1
    }
    return r
  }

  // (public) return the number of bits in "this"

  function bnBitLength () {
    if (this.t <= 0) return 0
    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM))
  }

  // (protected) r = this << n*DB

  function bnpDLShiftTo (n, r) {
    var i
    for (i = this.t - 1; i >= 0; --i) r[i + n] = this[i]
    for (i = n - 1; i >= 0; --i) r[i] = 0
    r.t = this.t + n
    r.s = this.s
  }

  // (protected) r = this >> n*DB

  function bnpDRShiftTo (n, r) {
    for (var i = n; i < this.t; ++i) r[i - n] = this[i]
    r.t = Math.max(this.t - n, 0)
    r.s = this.s
  }

  // (protected) r = this << n

  function bnpLShiftTo (n, r) {
    var bs = n % this.DB
    var cbs = this.DB - bs
    var bm = (1 << cbs) - 1
    var ds = Math.floor(n / this.DB),
      c = (this.s << bs) & this.DM,
      i
    for (i = this.t - 1; i >= 0; --i) {
      r[i + ds + 1] = (this[i] >> cbs) | c
      c = (this[i] & bm) << bs
    }
    for (i = ds - 1; i >= 0; --i) r[i] = 0
    r[ds] = c
    r.t = this.t + ds + 1
    r.s = this.s
    r.clamp()
  }

  // (protected) r = this >> n

  function bnpRShiftTo (n, r) {
    r.s = this.s
    var ds = Math.floor(n / this.DB)
    if (ds >= this.t) {
      r.t = 0
      return
    }
    var bs = n % this.DB
    var cbs = this.DB - bs
    var bm = (1 << bs) - 1
    r[0] = this[ds] >> bs
    for (var i = ds + 1; i < this.t; ++i) {
      r[i - ds - 1] |= (this[i] & bm) << cbs
      r[i - ds] = this[i] >> bs
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs
    r.t = this.t - ds
    r.clamp()
  }

  // (protected) r = this - a

  function bnpSubTo (a, r) {
    var i = 0,
      c = 0,
      m = Math.min(a.t, this.t)
    while (i < m) {
      c += this[i] - a[i]
      r[i++] = c & this.DM
      c >>= this.DB
    }
    if (a.t < this.t) {
      c -= a.s
      while (i < this.t) {
        c += this[i]
        r[i++] = c & this.DM
        c >>= this.DB
      }
      c += this.s
    } else {
      c += this.s
      while (i < a.t) {
        c -= a[i]
        r[i++] = c & this.DM
        c >>= this.DB
      }
      c -= a.s
    }
    r.s = (c < 0) ? -1 : 0
    if (c < -1) r[i++] = this.DV + c
    else if (c > 0) r[i++] = c
    r.t = i
    r.clamp()
  }

  // (protected) r = this * a, r != this,a (HAC 14.12)
  // "this" should be the larger one if appropriate.

  function bnpMultiplyTo (a, r) {
    var x = this.abs(),
      y = a.abs()
    var i = x.t
    r.t = i + y.t
    while (--i >= 0) r[i] = 0
    for (i = 0; i < y.t; ++i) r[i + x.t] = x.am(0, y[i], r, i, 0, x.t)
    r.s = 0
    r.clamp()
    if (this.s != a.s) BigInteger.ZERO.subTo(r, r)
  }

  // (protected) r = this^2, r != this (HAC 14.16)

  function bnpSquareTo (r) {
    var x = this.abs()
    var i = r.t = 2 * x.t
    while (--i >= 0) r[i] = 0
    for (i = 0; i < x.t - 1; ++i) {
      var c = x.am(i, x[i], r, 2 * i, 0, 1)
      if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
        r[i + x.t] -= x.DV
        r[i + x.t + 1] = 1
      }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1)
    r.s = 0
    r.clamp()
  }

  // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
  // r != q, this != m.  q or r may be null.

  function bnpDivRemTo (m, q, r) {
    var pm = m.abs()
    if (pm.t <= 0) return
    var pt = this.abs()
    if (pt.t < pm.t) {
      if (q != null) q.fromInt(0)
      if (r != null) this.copyTo(r)
      return
    }
    if (r == null) r = nbi()
    var y = nbi(),
      ts = this.s,
      ms = m.s
    var nsh = this.DB - nbits(pm[pm.t - 1]) // normalize modulus
    if (nsh > 0) {
      pm.lShiftTo(nsh, y)
      pt.lShiftTo(nsh, r)
    } else {
      pm.copyTo(y)
      pt.copyTo(r)
    }
    var ys = y.t
    var y0 = y[ys - 1]
    if (y0 == 0) return
    var yt = y0 * (1 << this.F1) + ((ys > 1) ? y[ys - 2] >> this.F2 : 0)
    var d1 = this.FV / yt,
      d2 = (1 << this.F1) / yt,
      e = 1 << this.F2
    var i = r.t,
      j = i - ys,
      t = (q == null) ? nbi() : q
    y.dlShiftTo(j, t)
    if (r.compareTo(t) >= 0) {
      r[r.t++] = 1
      r.subTo(t, r)
    }
    BigInteger.ONE.dlShiftTo(ys, t)
    t.subTo(y, y) // "negative" y so we can replace sub with am later
    while (y.t < ys) y[y.t++] = 0
    while (--j >= 0) {
      // Estimate quotient digit
      var qd = (r[--i] == y0) ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2)
      if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) { // Try it out
        y.dlShiftTo(j, t)
        r.subTo(t, r)
        while (r[i] < --qd) r.subTo(t, r)
      }
    }
    if (q != null) {
      r.drShiftTo(ys, q)
      if (ts != ms) BigInteger.ZERO.subTo(q, q)
    }
    r.t = ys
    r.clamp()
    if (nsh > 0) r.rShiftTo(nsh, r) // Denormalize remainder
    if (ts < 0) BigInteger.ZERO.subTo(r, r)
  }

  // (public) this mod a

  function bnMod (a) {
    var r = nbi()
    this.abs().divRemTo(a, null, r)
    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r)
    return r
  }

  // Modular reduction using "classic" algorithm

  function Classic (m) {
    this.m = m
  }

  function cConvert (x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m)
    else return x
  }

  function cRevert (x) {
    return x
  }

  function cReduce (x) {
    x.divRemTo(this.m, null, x)
  }

  function cMulTo (x, y, r) {
    x.multiplyTo(y, r)
    this.reduce(r)
  }

  function cSqrTo (x, r) {
    x.squareTo(r)
    this.reduce(r)
  }

  Classic.prototype.convert = cConvert
  Classic.prototype.revert = cRevert
  Classic.prototype.reduce = cReduce
  Classic.prototype.mulTo = cMulTo
  Classic.prototype.sqrTo = cSqrTo

  // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
  // justification:
  //         xy == 1 (mod m)
  //         xy =  1+km
  //   xy(2-xy) = (1+km)(1-km)
  // x[y(2-xy)] = 1-k^2m^2
  // x[y(2-xy)] == 1 (mod m^2)
  // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
  // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
  // JS multiply "overflows" differently from C/C++, so care is needed here.

  function bnpInvDigit () {
    if (this.t < 1) return 0
    var x = this[0]
    if ((x & 1) == 0) return 0
    var y = x & 3 // y == 1/x mod 2^2
    y = (y * (2 - (x & 0xf) * y)) & 0xf // y == 1/x mod 2^4
    y = (y * (2 - (x & 0xff) * y)) & 0xff // y == 1/x mod 2^8
    y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = (y * (2 - x * y % this.DV)) % this.DV // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return (y > 0) ? this.DV - y : -y
  }

  // Montgomery reduction

  function Montgomery (m) {
    this.m = m
    this.mp = m.invDigit()
    this.mpl = this.mp & 0x7fff
    this.mph = this.mp >> 15
    this.um = (1 << (m.DB - 15)) - 1
    this.mt2 = 2 * m.t
  }

  // xR mod m

  function montConvert (x) {
    var r = nbi()
    x.abs().dlShiftTo(this.m.t, r)
    r.divRemTo(this.m, null, r)
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r)
    return r
  }

  // x/R mod m

  function montRevert (x) {
    var r = nbi()
    x.copyTo(r)
    this.reduce(r)
    return r
  }

  // x = x/R mod m (HAC 14.32)

  function montReduce (x) {
    while (x.t <= this.mt2) // pad x so am has enough room later
    { x[x.t++] = 0 }
    for (var i = 0; i < this.m.t; ++i) {
      // faster way of calculating u0 = x[i]*mp mod DV
      var j = x[i] & 0x7fff
      var u0 = (j * this.mpl + (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) & x.DM
      // use am to combine the multiply-shift-add into one call
      j = i + this.m.t
      x[j] += this.m.am(0, u0, x, i, 0, this.m.t)
      // propagate carry
      while (x[j] >= x.DV) {
        x[j] -= x.DV
        x[++j]++
      }
    }
    x.clamp()
    x.drShiftTo(this.m.t, x)
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x)
  }

  // r = "x^2/R mod m"; x != r

  function montSqrTo (x, r) {
    x.squareTo(r)
    this.reduce(r)
  }

  // r = "xy/R mod m"; x,y != r

  function montMulTo (x, y, r) {
    x.multiplyTo(y, r)
    this.reduce(r)
  }

  Montgomery.prototype.convert = montConvert
  Montgomery.prototype.revert = montRevert
  Montgomery.prototype.reduce = montReduce
  Montgomery.prototype.mulTo = montMulTo
  Montgomery.prototype.sqrTo = montSqrTo

  // (protected) true iff this is even

  function bnpIsEven () {
    return ((this.t > 0) ? (this[0] & 1) : this.s) == 0
  }

  // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)

  function bnpExp (e, z) {
    if (e > 0xffffffff || e < 1) return BigInteger.ONE
    var r = nbi(),
      r2 = nbi(),
      g = z.convert(this),
      i = nbits(e) - 1
    g.copyTo(r)
    while (--i >= 0) {
      z.sqrTo(r, r2)
      if ((e & (1 << i)) > 0) z.mulTo(r2, g, r)
      else {
        var t = r
        r = r2
        r2 = t
      }
    }
    return z.revert(r)
  }

  // (public) this^e % m, 0 <= e < 2^32

  function bnModPowInt (e, m) {
    var z
    if (e < 256 || m.isEven()) z = new Classic(m)
    else z = new Montgomery(m)
    return this.exp(e, z)
  }

  // protected
  BigInteger.prototype.copyTo = bnpCopyTo
  BigInteger.prototype.fromInt = bnpFromInt
  BigInteger.prototype.fromString = bnpFromString
  BigInteger.prototype.clamp = bnpClamp
  BigInteger.prototype.dlShiftTo = bnpDLShiftTo
  BigInteger.prototype.drShiftTo = bnpDRShiftTo
  BigInteger.prototype.lShiftTo = bnpLShiftTo
  BigInteger.prototype.rShiftTo = bnpRShiftTo
  BigInteger.prototype.subTo = bnpSubTo
  BigInteger.prototype.multiplyTo = bnpMultiplyTo
  BigInteger.prototype.squareTo = bnpSquareTo
  BigInteger.prototype.divRemTo = bnpDivRemTo
  BigInteger.prototype.invDigit = bnpInvDigit
  BigInteger.prototype.isEven = bnpIsEven
  BigInteger.prototype.exp = bnpExp

  // public
  BigInteger.prototype.toString = bnToString
  BigInteger.prototype.negate = bnNegate
  BigInteger.prototype.abs = bnAbs
  BigInteger.prototype.compareTo = bnCompareTo
  BigInteger.prototype.bitLength = bnBitLength
  BigInteger.prototype.mod = bnMod
  BigInteger.prototype.modPowInt = bnModPowInt

  // "constants"
  BigInteger.ZERO = nbv(0)
  BigInteger.ONE = nbv(1)

  function bnClone () {
    var r = nbi()
    this.copyTo(r)
    return r
  }

  // (public) return value as integer

  function bnIntValue () {
    if (this.s < 0) {
      if (this.t == 1) return this[0] - this.DV
      else if (this.t == 0) return -1
    } else if (this.t == 1) return this[0]
    else if (this.t == 0) return 0
    // assumes 16 < DB < 32
    return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0]
  }

  // (public) return value as byte

  function bnByteValue () {
    return (this.t == 0) ? this.s : (this[0] << 24) >> 24
  }

  // (public) return value as short (assumes DB>=16)

  function bnShortValue () {
    return (this.t == 0) ? this.s : (this[0] << 16) >> 16
  }

  // (protected) return x s.t. r^x < DV

  function bnpChunkSize (r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r))
  }

  // (public) 0 if this == 0, 1 if this > 0

  function bnSigNum () {
    if (this.s < 0) return -1
    else if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0
    else return 1
  }

  // (protected) convert to radix string

  function bnpToRadix (b) {
    if (b == null) b = 10
    if (this.signum() == 0 || b < 2 || b > 36) return '0'
    var cs = this.chunkSize(b)
    var a = Math.pow(b, cs)
    var d = nbv(a),
      y = nbi(),
      z = nbi(),
      r = ''
    this.divRemTo(d, y, z)
    while (y.signum() > 0) {
      r = (a + z.intValue()).toString(b).substr(1) + r
      y.divRemTo(d, y, z)
    }
    return z.intValue().toString(b) + r
  }

  // (protected) convert from radix string

  function bnpFromRadix (s, b) {
    this.fromInt(0)
    if (b == null) b = 10
    var cs = this.chunkSize(b)
    var d = Math.pow(b, cs),
      mi = false,
      j = 0,
      w = 0
    for (var i = 0; i < s.length; ++i) {
      var x = intAt(s, i)
      if (x < 0) {
        if (s.charAt(i) == '-' && this.signum() == 0) mi = true
        continue
      }
      w = b * w + x
      if (++j >= cs) {
        this.dMultiply(d)
        this.dAddOffset(w, 0)
        j = 0
        w = 0
      }
    }
    if (j > 0) {
      this.dMultiply(Math.pow(b, j))
      this.dAddOffset(w, 0)
    }
    if (mi) BigInteger.ZERO.subTo(this, this)
  }

  // (protected) alternate constructor

  function bnpFromNumber (a, b, c) {
    if (typeof b === 'number') {
      // new BigInteger(int,int,RNG)
      if (a < 2) this.fromInt(1)
      else {
        this.fromNumber(a, c)
        if (!this.testBit(a - 1)) // force MSB set
        { this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this) }
        if (this.isEven()) this.dAddOffset(1, 0) // force odd
        while (!this.isProbablePrime(b)) {
          this.dAddOffset(2, 0)
          if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this)
        }
      }
    } else {
      // new BigInteger(int,RNG)
      var x = new Array(),
        t = a & 7
      x.length = (a >> 3) + 1
      b.nextBytes(x)
      if (t > 0) x[0] &= ((1 << t) - 1)
      else x[0] = 0
      this.fromString(x, 256)
    }
  }

  // (public) convert to bigendian byte array

  function bnToByteArray () {
    var i = this.t,
      r = new Array()
    r[0] = this.s
    var p = this.DB - (i * this.DB) % 8,
      d, k = 0
    if (i-- > 0) {
      if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | (this.s << (this.DB - p))
      while (i >= 0) {
        if (p < 8) {
          d = (this[i] & ((1 << p) - 1)) << (8 - p)
          d |= this[--i] >> (p += this.DB - 8)
        } else {
          d = (this[i] >> (p -= 8)) & 0xff
          if (p <= 0) {
            p += this.DB
            --i
          }
        }
        if ((d & 0x80) != 0) d |= -256
        if (k == 0 && (this.s & 0x80) != (d & 0x80))++k
        if (k > 0 || d != this.s) r[k++] = d
      }
    }
    return r
  }

  function bnEquals (a) {
    return (this.compareTo(a) == 0)
  }

  function bnMin (a) {
    return (this.compareTo(a) < 0) ? this : a
  }

  function bnMax (a) {
    return (this.compareTo(a) > 0) ? this : a
  }

  // (protected) r = this op a (bitwise)

  function bnpBitwiseTo (a, op, r) {
    var i, f, m = Math.min(a.t, this.t)
    for (i = 0; i < m; ++i) r[i] = op(this[i], a[i])
    if (a.t < this.t) {
      f = a.s & this.DM
      for (i = m; i < this.t; ++i) r[i] = op(this[i], f)
      r.t = this.t
    } else {
      f = this.s & this.DM
      for (i = m; i < a.t; ++i) r[i] = op(f, a[i])
      r.t = a.t
    }
    r.s = op(this.s, a.s)
    r.clamp()
  }

  // (public) this & a

  function op_and (x, y) {
    return x & y
  }

  function bnAnd (a) {
    var r = nbi()
    this.bitwiseTo(a, op_and, r)
    return r
  }

  // (public) this | a

  function op_or (x, y) {
    return x | y
  }

  function bnOr (a) {
    var r = nbi()
    this.bitwiseTo(a, op_or, r)
    return r
  }

  // (public) this ^ a

  function op_xor (x, y) {
    return x ^ y
  }

  function bnXor (a) {
    var r = nbi()
    this.bitwiseTo(a, op_xor, r)
    return r
  }

  // (public) this & ~a

  function op_andnot (x, y) {
    return x & ~y
  }

  function bnAndNot (a) {
    var r = nbi()
    this.bitwiseTo(a, op_andnot, r)
    return r
  }

  // (public) ~this

  function bnNot () {
    var r = nbi()
    for (var i = 0; i < this.t; ++i) r[i] = this.DM & ~this[i]
    r.t = this.t
    r.s = ~this.s
    return r
  }

  // (public) this << n

  function bnShiftLeft (n) {
    var r = nbi()
    if (n < 0) this.rShiftTo(-n, r)
    else this.lShiftTo(n, r)
    return r
  }

  // (public) this >> n

  function bnShiftRight (n) {
    var r = nbi()
    if (n < 0) this.lShiftTo(-n, r)
    else this.rShiftTo(n, r)
    return r
  }

  // return index of lowest 1-bit in x, x < 2^31

  function lbit (x) {
    if (x == 0) return -1
    var r = 0
    if ((x & 0xffff) == 0) {
      x >>= 16
      r += 16
    }
    if ((x & 0xff) == 0) {
      x >>= 8
      r += 8
    }
    if ((x & 0xf) == 0) {
      x >>= 4
      r += 4
    }
    if ((x & 3) == 0) {
      x >>= 2
      r += 2
    }
    if ((x & 1) == 0)++r
    return r
  }

  // (public) returns index of lowest 1-bit (or -1 if none)

  function bnGetLowestSetBit () {
    for (var i = 0; i < this.t; ++i) { if (this[i] != 0) return i * this.DB + lbit(this[i]) }
    if (this.s < 0) return this.t * this.DB
    return -1
  }

  // return number of 1 bits in x

  function cbit (x) {
    var r = 0
    while (x != 0) {
      x &= x - 1
      ++r
    }
    return r
  }

  // (public) return number of set bits

  function bnBitCount () {
    var r = 0,
      x = this.s & this.DM
    for (var i = 0; i < this.t; ++i) r += cbit(this[i] ^ x)
    return r
  }

  // (public) true iff nth bit is set

  function bnTestBit (n) {
    var j = Math.floor(n / this.DB)
    if (j >= this.t) return (this.s != 0)
    return ((this[j] & (1 << (n % this.DB))) != 0)
  }

  // (protected) this op (1<<n)

  function bnpChangeBit (n, op) {
    var r = BigInteger.ONE.shiftLeft(n)
    this.bitwiseTo(r, op, r)
    return r
  }

  // (public) this | (1<<n)

  function bnSetBit (n) {
    return this.changeBit(n, op_or)
  }

  // (public) this & ~(1<<n)

  function bnClearBit (n) {
    return this.changeBit(n, op_andnot)
  }

  // (public) this ^ (1<<n)

  function bnFlipBit (n) {
    return this.changeBit(n, op_xor)
  }

  // (protected) r = this + a

  function bnpAddTo (a, r) {
    var i = 0,
      c = 0,
      m = Math.min(a.t, this.t)
    while (i < m) {
      c += this[i] + a[i]
      r[i++] = c & this.DM
      c >>= this.DB
    }
    if (a.t < this.t) {
      c += a.s
      while (i < this.t) {
        c += this[i]
        r[i++] = c & this.DM
        c >>= this.DB
      }
      c += this.s
    } else {
      c += this.s
      while (i < a.t) {
        c += a[i]
        r[i++] = c & this.DM
        c >>= this.DB
      }
      c += a.s
    }
    r.s = (c < 0) ? -1 : 0
    if (c > 0) r[i++] = c
    else if (c < -1) r[i++] = this.DV + c
    r.t = i
    r.clamp()
  }

  // (public) this + a

  function bnAdd (a) {
    var r = nbi()
    this.addTo(a, r)
    return r
  }

  // (public) this - a

  function bnSubtract (a) {
    var r = nbi()
    this.subTo(a, r)
    return r
  }

  // (public) this * a

  function bnMultiply (a) {
    var r = nbi()
    this.multiplyTo(a, r)
    return r
  }

  // (public) this^2

  function bnSquare () {
    var r = nbi()
    this.squareTo(r)
    return r
  }

  // (public) this / a

  function bnDivide (a) {
    var r = nbi()
    this.divRemTo(a, r, null)
    return r
  }

  // (public) this % a

  function bnRemainder (a) {
    var r = nbi()
    this.divRemTo(a, null, r)
    return r
  }

  // (public) [this/a,this%a]

  function bnDivideAndRemainder (a) {
    var q = nbi(),
      r = nbi()
    this.divRemTo(a, q, r)
    return new Array(q, r)
  }

  // (protected) this *= n, this >= 0, 1 < n < DV

  function bnpDMultiply (n) {
    this[this.t] = this.am(0, n - 1, this, 0, 0, this.t)
    ++this.t
    this.clamp()
  }

  // (protected) this += n << w words, this >= 0

  function bnpDAddOffset (n, w) {
    if (n == 0) return
    while (this.t <= w) this[this.t++] = 0
    this[w] += n
    while (this[w] >= this.DV) {
      this[w] -= this.DV
      if (++w >= this.t) this[this.t++] = 0
      ++this[w]
    }
  }

  // A "null" reducer

  function NullExp () {}

  function nNop (x) {
    return x
  }

  function nMulTo (x, y, r) {
    x.multiplyTo(y, r)
  }

  function nSqrTo (x, r) {
    x.squareTo(r)
  }

  NullExp.prototype.convert = nNop
  NullExp.prototype.revert = nNop
  NullExp.prototype.mulTo = nMulTo
  NullExp.prototype.sqrTo = nSqrTo

  // (public) this^e

  function bnPow (e) {
    return this.exp(e, new NullExp())
  }

  // (protected) r = lower n words of "this * a", a.t <= n
  // "this" should be the larger one if appropriate.

  function bnpMultiplyLowerTo (a, n, r) {
    var i = Math.min(this.t + a.t, n)
    r.s = 0 // assumes a,this >= 0
    r.t = i
    while (i > 0) r[--i] = 0
    var j
    for (j = r.t - this.t; i < j; ++i) r[i + this.t] = this.am(0, a[i], r, i, 0, this.t)
    for (j = Math.min(a.t, n); i < j; ++i) this.am(0, a[i], r, i, 0, n - i)
    r.clamp()
  }

  // (protected) r = "this * a" without lower n words, n > 0
  // "this" should be the larger one if appropriate.

  function bnpMultiplyUpperTo (a, n, r) {
    --n
    var i = r.t = this.t + a.t - n
    r.s = 0 // assumes a,this >= 0
    while (--i >= 0) r[i] = 0
    for (i = Math.max(n - this.t, 0); i < a.t; ++i) { r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n) }
    r.clamp()
    r.drShiftTo(1, r)
  }

  // Barrett modular reduction

  function Barrett (m) {
    // setup Barrett
    this.r2 = nbi()
    this.q3 = nbi()
    BigInteger.ONE.dlShiftTo(2 * m.t, this.r2)
    this.mu = this.r2.divide(m)
    this.m = m
  }

  function barrettConvert (x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m)
    else if (x.compareTo(this.m) < 0) return x
    else {
      var r = nbi()
      x.copyTo(r)
      this.reduce(r)
      return r
    }
  }

  function barrettRevert (x) {
    return x
  }

  // x = x mod m (HAC 14.42)

  function barrettReduce (x) {
    x.drShiftTo(this.m.t - 1, this.r2)
    if (x.t > this.m.t + 1) {
      x.t = this.m.t + 1
      x.clamp()
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3)
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2)
    while (x.compareTo(this.r2) < 0) x.dAddOffset(1, this.m.t + 1)
    x.subTo(this.r2, x)
    while (x.compareTo(this.m) >= 0) x.subTo(this.m, x)
  }

  // r = x^2 mod m; x != r

  function barrettSqrTo (x, r) {
    x.squareTo(r)
    this.reduce(r)
  }

  // r = x*y mod m; x,y != r

  function barrettMulTo (x, y, r) {
    x.multiplyTo(y, r)
    this.reduce(r)
  }

  Barrett.prototype.convert = barrettConvert
  Barrett.prototype.revert = barrettRevert
  Barrett.prototype.reduce = barrettReduce
  Barrett.prototype.mulTo = barrettMulTo
  Barrett.prototype.sqrTo = barrettSqrTo

  // (public) this^e % m (HAC 14.85)

  function bnModPow (e, m) {
    var i = e.bitLength(),
      k, r = nbv(1),
      z
    if (i <= 0) return r
    else if (i < 18) k = 1
    else if (i < 48) k = 3
    else if (i < 144) k = 4
    else if (i < 768) k = 5
    else k = 6
    if (i < 8) z = new Classic(m)
    else if (m.isEven()) z = new Barrett(m)
    else z = new Montgomery(m)

    // precomputation
    var g = new Array(),
      n = 3,
      k1 = k - 1,
      km = (1 << k) - 1
    g[1] = z.convert(this)
    if (k > 1) {
      var g2 = nbi()
      z.sqrTo(g[1], g2)
      while (n <= km) {
        g[n] = nbi()
        z.mulTo(g2, g[n - 2], g[n])
        n += 2
      }
    }

    var j = e.t - 1,
      w, is1 = true,
      r2 = nbi(),
      t
    i = nbits(e[j]) - 1
    while (j >= 0) {
      if (i >= k1) w = (e[j] >> (i - k1)) & km
      else {
        w = (e[j] & ((1 << (i + 1)) - 1)) << (k1 - i)
        if (j > 0) w |= e[j - 1] >> (this.DB + i - k1)
      }

      n = k
      while ((w & 1) == 0) {
        w >>= 1
        --n
      }
      if ((i -= n) < 0) {
        i += this.DB
        --j
      }
      if (is1) { // ret == 1, don't bother squaring or multiplying it
        g[w].copyTo(r)
        is1 = false
      } else {
        while (n > 1) {
          z.sqrTo(r, r2)
          z.sqrTo(r2, r)
          n -= 2
        }
        if (n > 0) z.sqrTo(r, r2)
        else {
          t = r
          r = r2
          r2 = t
        }
        z.mulTo(r2, g[w], r)
      }

      while (j >= 0 && (e[j] & (1 << i)) == 0) {
        z.sqrTo(r, r2)
        t = r
        r = r2
        r2 = t
        if (--i < 0) {
          i = this.DB - 1
          --j
        }
      }
    }
    return z.revert(r)
  }

  // (public) gcd(this,a) (HAC 14.54)

  function bnGCD (a) {
    var x = (this.s < 0) ? this.negate() : this.clone()
    var y = (a.s < 0) ? a.negate() : a.clone()
    if (x.compareTo(y) < 0) {
      var t = x
      x = y
      y = t
    }
    var i = x.getLowestSetBit(),
      g = y.getLowestSetBit()
    if (g < 0) return x
    if (i < g) g = i
    if (g > 0) {
      x.rShiftTo(g, x)
      y.rShiftTo(g, y)
    }
    while (x.signum() > 0) {
      if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x)
      if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y)
      if (x.compareTo(y) >= 0) {
        x.subTo(y, x)
        x.rShiftTo(1, x)
      } else {
        y.subTo(x, y)
        y.rShiftTo(1, y)
      }
    }
    if (g > 0) y.lShiftTo(g, y)
    return y
  }

  // (protected) this % n, n < 2^26

  function bnpModInt (n) {
    if (n <= 0) return 0
    var d = this.DV % n,
      r = (this.s < 0) ? n - 1 : 0
    if (this.t > 0) {
      if (d == 0) r = this[0] % n
      else for (var i = this.t - 1; i >= 0; --i) r = (d * r + this[i]) % n
    }
    return r
  }

  // (public) 1/this % m (HAC 14.61)

  function bnModInverse (m) {
    var ac = m.isEven()
    if ((this.isEven() && ac) || m.signum() == 0) return BigInteger.ZERO
    var u = m.clone(),
      v = this.clone()
    var a = nbv(1),
      b = nbv(0),
      c = nbv(0),
      d = nbv(1)
    while (u.signum() != 0) {
      while (u.isEven()) {
        u.rShiftTo(1, u)
        if (ac) {
          if (!a.isEven() || !b.isEven()) {
            a.addTo(this, a)
            b.subTo(m, b)
          }
          a.rShiftTo(1, a)
        } else if (!b.isEven()) b.subTo(m, b)
        b.rShiftTo(1, b)
      }
      while (v.isEven()) {
        v.rShiftTo(1, v)
        if (ac) {
          if (!c.isEven() || !d.isEven()) {
            c.addTo(this, c)
            d.subTo(m, d)
          }
          c.rShiftTo(1, c)
        } else if (!d.isEven()) d.subTo(m, d)
        d.rShiftTo(1, d)
      }
      if (u.compareTo(v) >= 0) {
        u.subTo(v, u)
        if (ac) a.subTo(c, a)
        b.subTo(d, b)
      } else {
        v.subTo(u, v)
        if (ac) c.subTo(a, c)
        d.subTo(b, d)
      }
    }
    if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO
    if (d.compareTo(m) >= 0) return d.subtract(m)
    if (d.signum() < 0) d.addTo(m, d)
    else return d
    if (d.signum() < 0) return d.add(m)
    else return d
  }

  var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997]
  var lplim = (1 << 26) / lowprimes[lowprimes.length - 1]

  // (public) test primality with certainty >= 1-.5^t

  function bnIsProbablePrime (t) {
    var i, x = this.abs()
    if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
      for (i = 0; i < lowprimes.length; ++i) { if (x[0] == lowprimes[i]) return true }
      return false
    }
    if (x.isEven()) return false
    i = 1
    while (i < lowprimes.length) {
      var m = lowprimes[i],
        j = i + 1
      while (j < lowprimes.length && m < lplim) m *= lowprimes[j++]
      m = x.modInt(m)
      while (i < j) if (m % lowprimes[i++] == 0) return false
    }
    return x.millerRabin(t)
  }

  // (protected) true if probably prime (HAC 4.24, Miller-Rabin)

  function bnpMillerRabin (t) {
    var n1 = this.subtract(BigInteger.ONE)
    var k = n1.getLowestSetBit()
    if (k <= 0) return false
    var r = n1.shiftRight(k)
    t = (t + 1) >> 1
    if (t > lowprimes.length) t = lowprimes.length
    var a = nbi()
    for (var i = 0; i < t; ++i) {
      // Pick bases at random, instead of starting at 2
      a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)])
      var y = a.modPow(r, this)
      if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
        var j = 1
        while (j++ < k && y.compareTo(n1) != 0) {
          y = y.modPowInt(2, this)
          if (y.compareTo(BigInteger.ONE) == 0) return false
        }
        if (y.compareTo(n1) != 0) return false
      }
    }
    return true
  }

  // protected
  BigInteger.prototype.chunkSize = bnpChunkSize
  BigInteger.prototype.toRadix = bnpToRadix
  BigInteger.prototype.fromRadix = bnpFromRadix
  BigInteger.prototype.fromNumber = bnpFromNumber
  BigInteger.prototype.bitwiseTo = bnpBitwiseTo
  BigInteger.prototype.changeBit = bnpChangeBit
  BigInteger.prototype.addTo = bnpAddTo
  BigInteger.prototype.dMultiply = bnpDMultiply
  BigInteger.prototype.dAddOffset = bnpDAddOffset
  BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo
  BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo
  BigInteger.prototype.modInt = bnpModInt
  BigInteger.prototype.millerRabin = bnpMillerRabin

  // public
  BigInteger.prototype.clone = bnClone
  BigInteger.prototype.intValue = bnIntValue
  BigInteger.prototype.byteValue = bnByteValue
  BigInteger.prototype.shortValue = bnShortValue
  BigInteger.prototype.signum = bnSigNum
  BigInteger.prototype.toByteArray = bnToByteArray
  BigInteger.prototype.equals = bnEquals
  BigInteger.prototype.min = bnMin
  BigInteger.prototype.max = bnMax
  BigInteger.prototype.and = bnAnd
  BigInteger.prototype.or = bnOr
  BigInteger.prototype.xor = bnXor
  BigInteger.prototype.andNot = bnAndNot
  BigInteger.prototype.not = bnNot
  BigInteger.prototype.shiftLeft = bnShiftLeft
  BigInteger.prototype.shiftRight = bnShiftRight
  BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit
  BigInteger.prototype.bitCount = bnBitCount
  BigInteger.prototype.testBit = bnTestBit
  BigInteger.prototype.setBit = bnSetBit
  BigInteger.prototype.clearBit = bnClearBit
  BigInteger.prototype.flipBit = bnFlipBit
  BigInteger.prototype.add = bnAdd
  BigInteger.prototype.subtract = bnSubtract
  BigInteger.prototype.multiply = bnMultiply
  BigInteger.prototype.divide = bnDivide
  BigInteger.prototype.remainder = bnRemainder
  BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder
  BigInteger.prototype.modPow = bnModPow
  BigInteger.prototype.modInverse = bnModInverse
  BigInteger.prototype.pow = bnPow
  BigInteger.prototype.gcd = bnGCD
  BigInteger.prototype.isProbablePrime = bnIsProbablePrime

  // JSBN-specific extension
  BigInteger.prototype.square = bnSquare

  function Arcfour () {
    this.i = 0
    this.j = 0
    this.S = new Array()
  }

  // Initialize arcfour context from key, an array of ints, each from [0..255]
  function ARC4init (key) {
    var i, j, t
    for (i = 0; i < 256; ++i) { this.S[i] = i }
    j = 0
    for (i = 0; i < 256; ++i) {
      j = (j + this.S[i] + key[i % key.length]) & 255
      t = this.S[i]
      this.S[i] = this.S[j]
      this.S[j] = t
    }
    this.i = 0
    this.j = 0
  }

  function ARC4next () {
    var t
    this.i = (this.i + 1) & 255
    this.j = (this.j + this.S[this.i]) & 255
    t = this.S[this.i]
    this.S[this.i] = this.S[this.j]
    this.S[this.j] = t
    return this.S[(t + this.S[this.i]) & 255]
  }

  Arcfour.prototype.init = ARC4init
  Arcfour.prototype.next = ARC4next

  // Plug in your RNG constructor here
  function prng_newstate () {
    return new Arcfour()
  }

  var rng_psize = 256
  var rng_state
  var rng_pool
  var rng_pptr

  function rng_seed_int (x) {
    rng_pool[rng_pptr++] ^= x & 255
    rng_pool[rng_pptr++] ^= (x >> 8) & 255
    rng_pool[rng_pptr++] ^= (x >> 16) & 255
    rng_pool[rng_pptr++] ^= (x >> 24) & 255
    if (rng_pptr >= rng_psize) rng_pptr -= rng_psize
  }

  function rng_seed_time () {
    rng_seed_int(new Date().getTime())
  }

  if (rng_pool == null) {
    rng_pool = new Array()
    rng_pptr = 0
    var t
    if (navigator.appName == 'Netscape' && navigator.appVersion < '5' && window.crypto) {
      // Extract entropy (256 bits) from NS4 RNG if available
      if (typeof window.crypto.random === 'function') {
        var z = window.crypto.random(32)
        for (t = 0; t < z.length; ++t) { rng_pool[rng_pptr++] = z.charCodeAt(t) & 255 }
      }
    }
    while (rng_pptr < rng_psize) { // extract some randomness from Math.random()
      t = Math.floor(65536 * Math.random())
      rng_pool[rng_pptr++] = t >>> 8
      rng_pool[rng_pptr++] = t & 255
    }
    rng_pptr = 0
    rng_seed_time()
    // rng_seed_int(window.screenX);
    // rng_seed_int(window.screenY);
  }

  function rng_get_byte () {
    if (rng_state == null) {
      rng_seed_time()
      rng_state = prng_newstate()
      rng_state.init(rng_pool)
      for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr) { rng_pool[rng_pptr] = 0 }
      rng_pptr = 0
      // rng_pool = null;
    }
    // TODO: allow reseeding after first request
    return rng_state.next()
  }

  function rng_get_bytes (ba) {
    var i
    for (i = 0; i < ba.length; ++i) ba[i] = rng_get_byte()
  }

  function SecureRandom () {}

  SecureRandom.prototype.nextBytes = rng_get_bytes

  // Depends on jsbn.js and rng.js
  // Version 1.1: support utf-8 encoding in pkcs1pad2
  // convert a (hex) string to a bignum object

  function parseBigInt (str, r) {
    return new BigInteger(str, r)
  }

  function linebrk (s, n) {
    var ret = ''
    var i = 0
    while (i + n < s.length) {
      ret += s.substring(i, i + n) + '\n'
      i += n
    }
    return ret + s.substring(i, s.length)
  }

  function byte2Hex (b) {
    if (b < 0x10) return '0' + b.toString(16)
    else return b.toString(16)
  }

  // PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint

  function pkcs1pad2 (s, n) {
    if (n < s.length + 11) { // TODO: fix for utf-8
      // alert("Message too long for RSA (n=" + n + ", l=" + s.length + ")");
      // return null;
      throw 'Message too long for RSA (n=' + n + ', l=' + s.length + ')'
    }
    var ba = new Array()
    var i = s.length - 1
    while (i >= 0 && n > 0) {
      var c = s.charCodeAt(i--)
      if (c < 128) { // encode using utf-8
        ba[--n] = c
      } else if ((c > 127) && (c < 2048)) {
        ba[--n] = (c & 63) | 128
        ba[--n] = (c >> 6) | 192
      } else {
        ba[--n] = (c & 63) | 128
        ba[--n] = ((c >> 6) & 63) | 128
        ba[--n] = (c >> 12) | 224
      }
    }
    ba[--n] = 0
    var rng = new SecureRandom()
    var x = new Array()
    while (n > 2) { // random non-zero pad
      x[0] = 0
      while (x[0] == 0) rng.nextBytes(x)
      ba[--n] = x[0]
    }
    ba[--n] = 2
    ba[--n] = 0
    return new BigInteger(ba)
  }

  function RSAKey () {
    this.n = null
    this.e = 0
    this.d = null
    this.p = null
    this.q = null
    this.dmp1 = null
    this.dmq1 = null
    this.coeff = null
    this.base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  }
  function RSASetPublic (N, E) {
    if (N != null && E != null && N.length > 0 && E.length > 0) {
      this.n = parseBigInt(N, 16)
      this.e = parseInt(E, 16)
    } else alert('Invalid RSA public key')
  }
  function RSADoPublic (x) {
    return x.modPowInt(this.e, this.n)
  }
  function RSAEncrypt (text) {
    var m = pkcs1pad2(text, (this.n.bitLength() + 7) >> 3)
    if (m == null) return null
    var c = this.doPublic(m)
    if (c == null) return null
    var h = c.toString(16)
    if ((h.length & 1) == 0) return h
    else return '0' + h
  }
  RSAKey.prototype.doPublic = RSADoPublic
  RSAKey.prototype.setPublic = RSASetPublic
  RSAKey.prototype.encrypt = RSAEncrypt
  RSAKey.prototype.b64to16 = function (s) {
    var ret = ''
    var i
    var k = 0
    var slop
    for (i = 0; i < s.length; ++i) {
      if (s.charAt(i) == '=') break
      v = this.base64Chars.indexOf(s.charAt(i))
      if (v < 0) continue
      if (k == 0) {
        ret += int2char(v >> 2)
        slop = v & 3
        k = 1
      } else if (k == 1) {
        ret += int2char((slop << 2) | (v >> 4))
        slop = v & 0xf
        k = 2
      } else if (k == 2) {
        ret += int2char(slop)
        ret += int2char(v >> 2)
        slop = v & 3
        k = 3
      } else {
        ret += int2char((slop << 2) | (v >> 4))
        ret += int2char(v & 0xf)
        k = 0
      }
    }
    if (k == 1) ret += int2char(slop << 2)
    return ret
  }
  RSAKey.prototype.b16to64 = function (h) {
    var i
    var c
    var ret = ''
    if (h.length % 2 == 1) {
      h = '0' + h
    }
    for (i = 0; i + 3 <= h.length; i += 3) {
      c = parseInt(h.substring(i, i + 3), 16)
      ret += this.base64Chars.charAt(c >> 6) + this.base64Chars.charAt(c & 63)
    }
    if (i + 1 == h.length) {
      c = parseInt(h.substring(i, i + 1), 16)
      ret += this.base64Chars.charAt(c << 2)
    } else if (i + 2 == h.length) {
      c = parseInt(h.substring(i, i + 2), 16)
      ret += this.base64Chars.charAt(c >> 2) + this.base64Chars.charAt((c & 3) << 4)
    }
    while ((ret.length & 3) > 0) ret += '='
    return ret
  }
  RSAKey.prototype.setPublicByBase64 = function (N, E) {
    this.setPublic(this.b64to16(N), this.b64to16(E))
  }
  RSAKey.prototype.encryptToBase64 = function (text, keysize) {
    var allowMaxLength = Math.ceil(keysize / 8) - 11
    if (text.length <= allowMaxLength) {
      return this.b16to64(this.encrypt(text))
    } else {
      var hxCipher = ''
      while (text.length != 0) {
        hxCipher = hxCipher + this.encrypt(text.substring(0, allowMaxLength - 1))
        text = text.substring(allowMaxLength - 1, text.length)
      }
      return this.b16to64(hxCipher)
    }
  }

  return window.RSAKey = RSAKey
})



// WEBPACK FOOTER //
// ./src/utils/rsa.js